import { css } from 'emotion';
import { animationTransition } from '@joykit/variables';
import chroma from 'chroma-js';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';
import { bestContrast } from 'utils/color';

export namespace styles {
  const DESIGN_PANEL_WIDTH = 300;
  export const container = css({
    height: '100%'
  });
  export const designPanelWrapper = (mobile: boolean, show: boolean, color: string) =>
    css(
      {
        position: 'fixed',
        left: '0',
        top: '0',
        verticalAlign: 'top',
        bottom: '0',
        overflowY: 'scroll',
        zIndex: 5,
        backgroundColor: 'white',
        boxShadow: '0px 3px 10px rgba(0,0,0,0.15)',
        transition: animationTransition('left'),
        '::-webkit-scrollbar': {
          width: 8
        },
        '::-webkit-scrollbar-thumb': {
          backgroundColor: '#e8e8e8'
          // color
          //   ? chroma(color)
          //       .alpha(0.6)
          //       .css()
          //   : colors.neutral
        }
      },
      mobile
        ? {
            left: show ? 0 : '-100%'
          }
        : undefined
    );
  export const designPanelInner = css({
    width: DESIGN_PANEL_WIDTH,
    padding: '24px',
    minHeight: '100%'
    // borderRight: `1px solid ${colors.light}`
  });

  export const logo = css({
    marginBottom: 32
  });

  export const previewWrapper = (color: string, mobile: boolean) => {
    return css({
      width: mobile ? '100%' : `calc(100% - ${DESIGN_PANEL_WIDTH}px)`,
      marginLeft: mobile ? undefined : DESIGN_PANEL_WIDTH,
      overflow: 'hidden',
      transition: animationTransition('background-color'),
      backgroundColor: color
        ? chroma(color)
            .alpha(0.6)
            .css()
        : '#f5f5f5',
      position: 'relative'
    });
  };

  export const previewContent = css({
    maxWidth: '80%',
    margin: '0 auto',
    height: 'calc(100vh - 200px)'
    // position: 'relative'
  });

  export const deviceContainer = css({
    position: 'absolute',
    top: 0,
    width: '100%'
  });
  export const previewContainer = css({});

  export const desktopShell = css({
    width: '100%'
  });

  export const startButtonContainer = css({
    height: 100,
    display: 'flex',
    alignItems: 'center'
  });

  export const startButton = (color: string) => {
    const backgroundColor = (value: number) =>
      chroma(color)
        .darken(value)
        .css();

    // const defaultBackgroundColor = backgroundColor(0.4);
    return css({
      backgroundColor: backgroundColor(0.4),
      ...getInterUIDynamicMetricCssObject(15),
      color: bestContrast(backgroundColor(0.4), '#FFF', '#333'),
      position: 'relative',
      left: '50%',
      transform: 'translateX(-50%)',
      padding: '16px 48px',
      fontWeight: 'bold',
      borderRadius: '3px',
      transition: animationTransition('background-color'),
      whiteSpace: 'nowrap',
      ':hover': {
        backgroundColor: backgroundColor(1)
      }
    });
  };

  export const createWeddingWrapper = css({
    display: 'flex',
    justifyContent: 'center',
    '> div > div': {
      maxWidth: 800
    }
  });

  export const popupPosition = css({
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 10
  });
}
